import { useEffect } from 'react';

export const useAnchorScroll = (anchor: string, elementRef: React.RefObject<any>) => {
    const href = typeof window !== 'undefined' && window.location.href;
    useEffect(() => {
        if (href && href.includes(`#${anchor}`)) {
            if (elementRef && elementRef.current) {
                const { offsetTop } = elementRef.current;
                typeof window !== 'undefined' &&
                    window.scrollTo({
                        top: offsetTop,
                        left: 0,
                        behavior: 'smooth',
                    });
            }
        }
    }, [elementRef]);

    return;
};
